import { render, staticRenderFns } from "./UserInfoCard.vue?vue&type=template&id=92137190&scoped=true"
import script from "./UserInfoCard.vue?vue&type=script&lang=js"
export * from "./UserInfoCard.vue?vue&type=script&lang=js"
import style0 from "./UserInfoCard.vue?vue&type=style&index=0&id=92137190&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92137190",
  null
  
)

export default component.exports